/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DxpRoleIdType, DxpServiceToken } from '@squiz/dxp-auth';
import { useConsoleServiceStore } from 'dxpConsoleCore-mf/State';
import { DXP_CONSOLE_SQUIZ_ROOT_REFERENCE_ID } from '../../Constants/App.constants';

/**
 * Derive the user's roles in the specified tenant.
 */
export const getUserRolesInTenant = (tenantReferenceId: string): Array<DxpRoleIdType> => {
  const { tokens }: { tokens: Array<DxpServiceToken> | null } = useConsoleServiceStore.getState();

  if (!tokens) {
    return [];
  }

  let roles;

  // Get the DXP service token for the tenant as well as the root tenant.
  const rootToken = tokens.find((token) => token.tenant === DXP_CONSOLE_SQUIZ_ROOT_REFERENCE_ID);
  const tenantToken = tokens.find((token) => token.tenant === tenantReferenceId);

  if (rootToken) {
    roles = rootToken.roles;
  } else if (tenantToken) {
    roles = tenantToken.roles;
  }

  return roles ?? [];
};
